import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useCheckPaymentsPossibility = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const fetchData = async () => {
    const response = await dispatch.application.getPaymentsEnabled();
    const { isAvailable } = response;
    dispatch.application[isAvailable ? 'enablePayments' : 'disablePayments']();
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return { loading };
};

export default useCheckPaymentsPossibility;
